import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface ITeleMedicine {
    open?: boolean;
    url?: string;
    value?: string;
    record?: boolean;
    islemGrupId?: number;
};

const TeleMedicineSlice = createSlice<ITeleMedicine, MapReducerPayloads<ITeleMedicine, {
    setOpen?: boolean;
    setUrl?: string;
    setValue?: string;
    setRecord?: boolean;
    setIslemGrupId?: number;
}>>({
    name: 'TeleMedicineState',
    initialState: {
        url: null,
        value: '0',
        open: false,
        record: false,
        islemGrupId: null
    },
    reducers: {
        setUrl: (state, action) => {
            state.url = action.payload
        },
        setValue: (state, action) => {
            state.value = action.payload
        },
        setOpen: (state, action) => {
            state.open = action.payload
        },
        setRecord: (state, action) => {
            state.record = action.payload
        },
        setIslemGrupId: (state, action) => {
            state.islemGrupId = action.payload
        }
    }
});

export default TeleMedicineSlice;